import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinpuneforcorporate() {



const cardData =
  {
    keyword: 'Urbania On Rent in Pune for Corporate',
    heading: 'Sanavi Travels: Urbania On Rent in Pune for Corporate',
    headingDescription: 'Sanavi Travels provides premium and highly dependable Urbania On Rent in Pune for Corporate travel, specially designed for companies, IT firms, MNCs, factories, startups, business houses, and professional organizations that require organized and comfortable group transportation. Force Urbania has emerged as one of the most preferred corporate people movers due to its modern design, spacious interiors, executive seating layout, smooth suspension, and excellent ride comfort. Hiring an Urbania for corporate use in Pune is ideal for office transport, employee pickup and drop, corporate meetings, conferences, seminars, training programs, exhibitions, plant visits, offsite meetings, and VIP corporate events. The Urbania offers ample legroom, wide aisles, large windows, advanced safety features, and sufficient luggage space, making it suitable for both short city commutes and long-distance corporate travel. Sanavi Travels offers multiple seating options including 9 seater, 13 seater, 15 seater, and 17 seater Urbania vehicles, all maintained to high corporate standards and driven by trained, uniformed, and background-verified chauffeurs who understand punctuality, corporate etiquette, confidentiality, and route optimization. With flexible hourly, daily, and monthly corporate rental packages, transparent billing, dedicated coordination teams, and 24/7 operational support, Sanavi Travels ensures seamless, safe, and professional corporate mobility across Pune city, IT parks, MIDC zones, business hubs, and nearby outstation locations. Choosing Urbania on rent in Pune for corporate travel ensures efficiency, comfort, scalability, and a strong professional impression for every business journey.',

    top: 'Corporate Use Cases for Urbania Rental in Pune',


"topPlaces": [
  {
    "title": "Office Transport and Daily Corporate Commute",
    "description": "Urbania is widely used for daily office transport and corporate commute in Pune, especially for teams traveling together from residential areas to IT parks, business hubs, and industrial zones. The spacious interiors, comfortable seating, and smooth ride help employees start and end their workday without travel fatigue. Companies benefit from punctual arrivals, improved attendance, and higher employee satisfaction through organized Urbania office transport services."
  },
  {
    "title": "Employee Pickup and Drop Services",
    "description": "Urbania for employee pickup and drop is ideal for organizations operating in shifts or managing large teams. With multiple seating configurations and professional drivers, Urbania ensures safe, reliable, and well-coordinated employee transportation across Pune, including early morning and late-night shifts, while maintaining strict safety and timing protocols."
  },
  {
    "title": "Corporate Meetings and Client Visits",
    "description": "For corporate meetings and client visits, Urbania offers a professional group travel solution that allows teams to move together comfortably. Executives can travel in a calm, spacious environment, discuss agendas, and arrive at meetings relaxed and on time, enhancing overall business productivity."
  },
  {
    "title": "Conferences and Corporate Events",
    "description": "Urbania is frequently hired for conferences, seminars, exhibitions, and large corporate events in Pune. It supports smooth transportation of delegates, speakers, and staff between offices, hotels, and event venues, ensuring timely coordination and professional event logistics."
  },
  {
    "title": "Seminars and Training Programs",
    "description": "Companies conducting seminars, workshops, and training programs prefer Urbania for group transportation. The vehicle’s comfort and space allow participants to travel together efficiently, reducing logistical complexity and ensuring smooth execution of corporate learning events."
  },
  {
    "title": "Corporate Team Outings and Offsites",
    "description": "Urbania is ideal for corporate team outings, offsite meetings, and team-building programs around Pune. It offers comfortable group travel for short trips or full-day outings, helping teams travel together safely while promoting coordination and bonding."
  },
  {
    "title": "Industrial and MIDC Area Travel",
    "description": "Organizations operating in MIDC and industrial areas use Urbania for safe and dependable transport of staff, engineers, and management to factories, plants, and project sites. The vehicle handles long routes and varying road conditions efficiently."
  },
  {
    "title": "Outstation Corporate Travel",
    "description": "For outstation corporate travel from Pune to nearby cities and industrial locations, Urbania provides comfort, stability, and reliability. It is suitable for audits, inspections, training visits, and intercity corporate travel."
  },
  {
    "title": "VIP and Executive Group Transport",
    "description": "Urbania is also chosen for VIP and executive group transport during corporate events. Its modern appearance, premium interiors, and professional chauffeur service create a refined corporate travel experience."
  },
  {
    "title": "Multi-Day Corporate Rentals",
    "description": "Urbania can be hired for multi-day corporate events, conferences, and tours, offering consistent service quality and flexibility throughout the engagement period."
  }
]
,



"services": [
{
"name": "Urbania On Rent in Pune for Corporate",
"description": "Urbania On Rent in Pune for Corporate offers a modern and efficient group transportation solution for businesses of all sizes. Ideal for office transport, employee movement, meetings, conferences, and corporate events, this service ensures punctuality, comfort, and professional execution. Sanavi Travels provides well-maintained vehicles, trained chauffeurs, transparent pricing, and flexible rental plans to support smooth corporate operations."
},
{
"name": "Urbania Corporate Hire Pune",
"description": "Urbania Corporate Hire Pune delivers scalable and reliable transport solutions for companies requiring organized group travel. It supports daily commute, executive movement, and event transportation with consistent service standards."
},
{
"name": "Urbania for Office Transport Pune",
"description": "Urbania for Office Transport Pune supports daily employee commuting with fixed schedules, route planning, and reliable service, helping organizations maintain punctuality and workforce efficiency."
},
{
"name": "Urbania for Employee Pickup Pune",
"description": "Urbania for Employee Pickup Pune ensures safe, coordinated, and timely transportation for employees across shifts and locations, reducing travel stress and improving attendance."
},
{
"name": "Urbania for Corporate Meetings Pune",
"description": "Urbania for Corporate Meetings Pune provides comfortable and professional group travel for executives attending meetings across Pune, allowing teams to travel together efficiently."
},
{
"name": "Urbania for Conferences Pune",
"description": "Urbania for Conferences Pune manages transportation for delegates, speakers, and corporate teams attending conferences and exhibitions, ensuring smooth event logistics."
},
{
"name": "Urbania for Seminars Pune",
"description": "Urbania for Seminars Pune supports group travel for workshops, training programs, and seminars, helping organizations execute learning events seamlessly."
},
{
"name": "9 Seater Urbania Corporate Rental Pune",
"description": "9 Seater Urbania Corporate Rental Pune is ideal for small executive teams, offering premium comfort, privacy, and professional travel for business use."
},
{
"name": "13 Seater Urbania Corporate Hire Pune",
"description": "13 Seater Urbania Corporate Hire Pune is suitable for medium-sized corporate teams, providing ample space and comfort for meetings, events, and office travel."
},
{
"name": "15 Seater Urbania Corporate Rental Pune",
"description": "15 Seater Urbania Corporate Rental Pune supports larger teams traveling together for conferences, training sessions, and offsite meetings."
},
{
"name": "17 Seater Urbania Corporate Hire Pune",
"description": "17 Seater Urbania Corporate Hire Pune offers high-capacity group transport for corporate events, employee movement, and large team travel requirements."
},
{
"name": "Luxury Urbania for Corporate Events Pune",
"description": "Luxury Urbania for Corporate Events Pune delivers a premium group travel experience with modern interiors, smooth ride quality, and professional chauffeurs."
},
{
"name": "Affordable Urbania Corporate Rental Pune",
"description": "Affordable Urbania Corporate Rental Pune provides competitive pricing and transparent billing, making corporate group transport cost-effective without compromising quality."
},
{
"name": "Best Urbania Corporate Service Pune",
"description": "Best Urbania Corporate Service Pune by Sanavi Travels is trusted for punctuality, vehicle quality, professional drivers, and consistent corporate service standards."
},
{
"name": "Urbania Hire with Driver for Corporate Pune",
"description": "Urbania Hire with Driver for Corporate Pune includes experienced chauffeurs trained in corporate etiquette, safety protocols, and efficient route management."
}
],
"tableData": [
["Urbania Corporate Pune", "Urbania Office Transport Pune"],
["Urbania Employee Pickup Pune", "Urbania Corporate Meetings Pune"],
["Urbania Conference Travel Pune", "Urbania Seminar Travel Pune"],
["9 Seater Urbania Pune", "13 Seater Urbania Pune"],
["15 Seater Urbania Pune", "17 Seater Urbania Pune"],
["Affordable Urbania Pune", "Best Urbania Corporate Service Pune"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Urbania Corporate Rental with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels delivers professional and scalable Urbania rental services tailored for corporate travel in Pune."
  },
  {
    "WhyChooseheading": "Modern and Spacious Vehicles",
    "WhyChoosedescription": "Urbania offers wide seating, ample legroom, and smooth ride quality ideal for group corporate travel."
  },
  {
    "WhyChooseheading": "Trained Corporate Chauffeurs",
    "WhyChoosedescription": "Drivers are professionally trained, background-verified, and experienced in corporate travel standards."
  },
  {
    "WhyChooseheading": "Flexible Corporate Rental Packages",
    "WhyChoosedescription": "Hourly, daily, and monthly rental options are available based on corporate travel needs."
  },
  {
    "WhyChooseheading": "Transparent Billing System",
    "WhyChoosedescription": "Clear pricing, structured invoices, and no hidden charges simplify corporate expense management."
  },
  {
    "WhyChooseheading": "Suitable for All Corporate Requirements",
    "WhyChoosedescription": "Ideal for office transport, employee pickup, meetings, conferences, seminars, and corporate events."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Fleet",
    "WhyChoosedescription": "All Urbania vehicles are regularly serviced, cleaned, and sanitized before deployment."
  },
  {
    "WhyChooseheading": "24/7 Corporate Support",
    "WhyChoosedescription": "Dedicated support teams ensure smooth coordination and assistance throughout corporate journeys."
  }
]

}

const faqData = [
  {
    question: 'Do you provide Urbania on rent in Pune for corporate travel?',
    answer: 'Yes, Sanavi Travels offers Urbania rentals in Pune specifically for corporate and business travel.'
  },
  {
    question: 'Is Urbania suitable for employee pickup and office transport?',
    answer: 'Yes, Urbania is ideal for employee pickup, office commute, and group corporate travel.'
  },
  {
    question: 'What seating options are available in Urbania?',
    answer: 'We offer 9 seater, 13 seater, 15 seater, and 17 seater Urbania options.'
  },
  {
    question: 'Are drivers trained for corporate etiquette?',
    answer: 'Yes, all drivers are professionally trained and background-verified.'
  },
  {
    question: 'Do you offer long-term corporate rental packages?',
    answer: 'Yes, flexible long-term and monthly corporate rental packages are available.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Mehta',
    feedback: 'Excellent Urbania service for our corporate seminars. Very comfortable and well managed.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Kavita Nair',
    feedback: 'We use Urbania regularly for employee transport. Sanavi Travels provides reliable service.',
    rating: 5
  }
];



























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Pune for Corporate - Sanavi Travels",
  "description": "Sanavi Travels offers Urbania on rent in Pune for corporate purposes, including office transport, employee pickups, meetings, conferences, and seminars. 9-seater, 13-seater, 15-seater, and 17-seater Urbania vehicles are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};







  return (
    <div>

<Helmet>
  <title>
    Urbania On Rent in Pune for Corporate | Luxury Group Travel | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Urbania on rent in Pune for corporate travel, employee transport, business events, airport transfers and group outings. Luxury 9 to 17 seater van with professional driver."
  />

  <meta
    name="keywords"
    content="Urbania On Rent in Pune for Corporate, Force Urbania Rental Pune, Corporate Urbania Hire Pune, Luxury Van Pune, Group Travel Pune, Business Travel Urbania Pune"
  />

  <link
    rel="canonical"
    href="https://www.sanavitravels.com/urbania-on-rent-in-pune-for-corporate"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Urbania On Rent in Pune for Corporate | Sanavi Travels"
  />
  <meta
    property="og:description"
    content="Luxury Force Urbania rental in Pune for corporate travel, events, airport transfers and group transportation."
  />
  <meta
    property="og:url"
    content="https://www.sanavitravels.com/urbania-on-rent-in-pune-for-corporate"
  />

  {/* Schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Urbania On Rent in Pune for Corporate",
      "serviceType": "Corporate Group Transportation",
      "provider": {
        "@type": "LocalBusiness",
        "name": "Sanavi Travels",
        "telephone": "+91 7387507373"
      },
      "areaServed": {
        "@type": "City",
        "name": "Pune"
      },
      "description":
        "Force Urbania rental in Pune for corporate travel, employee transport, business events, airport transfers and group tours.",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": 4.7,
        "bestRating": 5,
        "worstRating": 1,
        "ratingCount": 10000
      }
    })}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/255.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniaonrentinpuneforcorporate;